import type { PrimeNGConfigType } from 'primeng/config';

// Render outside scrollable containers and above application modal layers.
export const NIMMSTA_PRIMENG_OVERLAY_CONFIG = {
  overlayAppendTo: 'body',
  overlayOptions: { baseZIndex: 1200 },
} satisfies PrimeNGConfigType;
